import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import LocalizationUtil from "../../../../../localization/LocalizationUtil";
import { messages } from "../../../../../localization/messages";
import DocumentService from "../../../../../services/DocumentService";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import WebServiceConsumer from "../../../../../services/WebServiceConsumer";
import CommonUtil from "../../../../../utils/CommonUtil";
import { constants } from "../../../../../utils/Constants";
import {
  knowledgeItemValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import TableComponent from "../../../page/TableComponent";
import Document from "./Document";
import { labels } from "../../../../../localization/labels";


class DocumentContainer extends TableComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      documentForUpload: {
        noDateRange: true,
        documentType: constants.DOCUMENT_TYPE.FILE,
        previewUrl: "",
        downloadUrl: ""
      },
      disabled: true,
      disabledUpdateDocument: true,
      selectedDocument: {},
      showEditDialog: false,
      showUploader: false,
      showSimilarDocuments: {
        showModal: false,
        document: undefined
      },
      selectedDocumentType: constants.DOCUMENT_TYPE.FILE.id
    };

    this.entity = this.props.entity;
    this.documentService = new DocumentService(this.keycloak);
    this.serviceConsumer = new WebServiceConsumer();
    this.fileUploaderRef = React.createRef();
    this.onDocumentSelect = this.onDocumentSelect.bind(this);
    this.startUploading = this.startUploading.bind(this);
    this.props.setStartUploading &&
    this.props.setStartUploading(this.startUploading);
  }

  componentDidMount() {
    this.entity = this.props.entity;
    super.componentDidMount();
  }

  componentDidUpdate() {
    this.entity = this.props.entity;
    super.componentDidUpdate();
  }

  startUploading(entity) {
    this.entity = entity;
    if (this.fileUploaderRef && this.fileUploaderRef.current) {
      this.fileUploaderRef.current.onUpload();
    }
  }

  possibleSizesPerPage() {
    return [3, 5, 10];
  }

  loadData = pageInfo => {
    const entity = this.entity;
    if (entity && entity._links) {
      this.documentLoading = true;
      const url = entity._links.documents.href;
      const documentFilterInfo = {
        ...pageInfo,
        ...activeFilterPageInfo
      };
      const sortInfo = {
        orderBy: "id",
        direction: "desc"
      };
      this.prepareCall(
        this.documentService.getEntitiesWithParams(
          url,
          documentFilterInfo,
          sortInfo,
          this.onDataLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onDataLoad(data) {
    super.onDataLoad(data);
    const numberOfDocuments = data.page.totalElements;
    this.props.setNumberOfDocuments &&
    this.props.setNumberOfDocuments(numberOfDocuments);
  }

  onDownloadClick = (doc, isPreview) => {
    let confirm;
    const documentTypeFile = doc.documentType === constants.DOCUMENT_TYPE.FILE.id
    if (documentTypeFile) {
      confirm = window.confirm(messages.download_confirm_message);
    } else {
      confirm = isPreview ? window.confirm(messages.preview_url_confirm_message) : window.confirm(messages.download_url_confirm_message);
    }
    if (confirm && documentTypeFile) {
      this.prepareCall(
        this.documentService.downloadDocument(
          doc._links.download.href,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    } else if (confirm && !documentTypeFile) {
      const link = document.createElement('a');
      if (isPreview) {
        link.href = doc.previewUrl !== "" ? doc.previewUrl : doc.downloadUrl;
      } else {
        link.href = doc.downloadUrl !== "" ? doc.downloadUrl : doc.previewUrl;
      }
      link.target = "_blank";
      link.click();
      link.remove();
    }
  };

  onRowClick = (_, row) => {
    this.onDownloadClick(row, true);
  };

  onEditClick = document => {
    const selfUrl = document._links.self.href;
    this.prepareCall(
      this.documentService.getEntitiesByUrl(
        selfUrl,
        this.onDocumentLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDocumentLoad = data => {
    const document = data;
    let docType = constants.DOCUMENT_TYPE.FILE;
    if (data.documentType === constants.DOCUMENT_TYPE.LINK.id) {
      docType = constants.DOCUMENT_TYPE.LINK;
    }
    document.documentType = docType;
    document.noDateRange = true;
    // check which fields are required
    this.validator(document);
    this.handleShowEditDialog();
    this.setState({
      selectedDocument: { ...document },
      oldDocument: { ...document },
      disabledUpdateDocument: false
    });
  };

  onDeleteClick = (document, onSuccess) => {
    this.prepareCall(
      this.documentService.deleteEntity(
        document,
        undefined,
        this.onDeleteSuccess,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDeleteSuccess = () => {
    this.onDeleteSuccessMessage();
    this.loadData(this.state.pageInfo);
  };

  onUploadClick = (files) => {
    let documentForUpload = this.state.documentForUpload;
    const selectedDocType = this.state.documentForUpload.documentType.id;
    documentForUpload["entities"] = [this.entity];
    if (selectedDocType === constants.DOCUMENT_TYPE.FILE.id) {
      documentForUpload["documentType"] = constants.DOCUMENT_TYPE.FILE.name;
      documentForUpload["fileName"] = files[0].name;
      documentForUpload["contentType"] =
        files[0].type && files[0].type !== ""
          ? files[0].type.toLowerCase()
          : undefined;
      if (this.props.hideCreateForm) {
        documentForUpload["name"] = files[0].name;
      }
      documentForUpload["unzip"] = true;
      documentForUpload["size"] = files[0].size;
      this.upload(documentForUpload, files);
    } else {
      // saving empty file for act of saving link
      documentForUpload["documentType"] = constants.DOCUMENT_TYPE.LINK.name;
      documentForUpload["fileName"] = "";
      documentForUpload["contentType"] = undefined;
      documentForUpload["unzip"] = false;

      const newFile = {
        name: "",
        originFileObj: {
          uid: "",
          lastModified: 0,
          name: "",
          size: 1,
          type: "unknown"
        }
      }
      const newFiles = [];
      newFiles.push(newFile);

      this.upload(documentForUpload, newFiles);
    }

  };

  upload = (documentForUpload, files) => {
    this.prepareCall(
      this.documentService.postDocument(
        documentForUpload,
        files,
        this.onUploadSuccess,
        message => this.onUploadWarning(message, documentForUpload, files)
      )
    );
    this.performCalls();
  };

  onUploadWarning = (message, documentForUpload, files) => {
    if (message && message.code === constants.MAX_ZIP_FILES_ERROR_CODE) {
      const text = LocalizationUtil.localize(message.text);
      if (window.confirm(text.text)) {
        documentForUpload["unzip"] = false;

        this.upload(documentForUpload, files);
      }
    } else {
      this.messageHandler.handleError(message);
    }
  };

  onUploadSuccess = data => {
    if (this.fileUploaderRef && this.fileUploaderRef.current) {
      this.fileUploaderRef.current.reset();
    }
    const unsavedDocumentNames = CommonUtil.getDataContent(data)
      .filter(document => document.empty)
      .map(document => document.name);
    if (unsavedDocumentNames.length) {
      const files = CommonUtil.concatStringsWithDelimiter(
        ", ",
        unsavedDocumentNames
      );
      this.onWarningMessage(
        `${messages.empty_files_unzipped_message} ${files}`
      );
    } else {
      this.onSaveSuccessMessage();
    }
    this.setState({
      documentForUpload: { noDateRange: true, documentType: constants.DOCUMENT_TYPE.FILE, previewUrl: "", downloadUrl: "" },
      showUploader: false
    });
    if (!this.props.hideCreateForm) {
      this.startLoading(this.state.pageInfo, this.sortInfo);
    }
  };

  onSave = event => {
    this.prepareCall(
      this.documentService.patchEntity(
        this.state.selectedDocument,
        this.state.oldDocument,
        this.onSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onSaveResponse = data => {
    this.onSaveSuccessMessage();
    this.loadData(this.state.pageInfo);
    this.handleCloseEditDialog();
  };

  onDocumentSelect = file => {
    if (file) {
      if (
        !this.state.documentForUpload.name ||
        !this.state.documentForUpload.name.length
      ) {
        let name = file.name.split(".")[0];
        if (name.length > this.maxLength.name) {
          name = name.substr(0, this.maxLength.name);
        }
        this.onChange({ target: { id: "name", value: name } });
      }
    }
  };

  setSelected = isSelected => {
    this.setState({ isSelected });
  };

  onChange = event => {
    var documentForUpload = this.state.documentForUpload;
    documentForUpload[event.target.id] = event.target.value;
    const disabled = !this.validator(documentForUpload);
    if(documentForUpload.documentType.id === constants.DOCUMENT_TYPE.LINK.id) {
      this.checkMultimediaFieldsPrefilled(documentForUpload);
    }
    this.setState({
      documentForUpload: documentForUpload,
      disabled: disabled
    });
  };

  checkMultimediaFieldsPrefilled = (document) => {
    if (document["name"] !== "" && (document["previewUrl"] !== "" || document["downloadUrl"] !== "")) {
      this.setSelected(true);
    } else {
      this.setSelected(false);
    }
  }

  onDocumentEditChange = event => {
    var documentForUpdate = this.state.selectedDocument;
    documentForUpdate[event.target.id] = event.target.value;
    const disabled = !this.validator(documentForUpdate);
    if(documentForUpdate.documentType.id === constants.DOCUMENT_TYPE.LINK.id) {
      this.checkMultimediaFieldsPrefilled(documentForUpdate);
    }
    this.setState({
      selectedDocument: documentForUpdate,
      disabledUpdateDocument: disabled
    });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.document);
  };

  handleShowEditDialog = () => {
    this.setState({ showEditDialog: true });
  };

  handleCloseEditDialog = () => {
    this.setState({ showEditDialog: false });
  };

  handleShowUploader = () => {
    this.setState({ showUploader: true });
  };

  handleCloseUploader = () => {
    this.setState({ showUploader: false, isSelected: false });
  };

  maxLength = {
    name: 255,
    description: 2000
  };

  onShowSimilarDocuments = document => {
    this.setState({
      showSimilarDocuments: {
        showModal: true,
        document: document
      }
    });
  };

  handleCloseSimilarDocuments = () => {
    this.setState({
      showSimilarDocuments: {
        showModal: false,
        document: undefined
      }
    });
  };

  render() {
    const paginationOptions = this.constructPaginationOptions();
    const docTypesOptions = [
      { id: constants.DOCUMENT_TYPE.FILE.id, name: labels.documentTypeFile },
      { id: constants.DOCUMENT_TYPE.LINK.id, name: labels.documentTypeLink }
    ];

    return (
      <Document
        documents={this.state.content}
        onEditClick={this.onEditClick}
        onDocumentDownload={this.onDownloadClick}
        onDocumentsUpload={this.onUploadClick}
        onDocumentDelete={this.onDeleteClick}
        fileUploaderRef={this.fileUploaderRef}
        documentForUpload={this.state.documentForUpload}
        onDocumentSelect={this.onDocumentSelect}
        onChange={this.onChange}
        disabledUpdateDocument={this.state.disabledUpdateDocument}
        disabled={this.state.disabled || !this.state.isSelected}
        validationRules={validationRules.document}
        paginationOptions={paginationOptions}
        handleTableChange={this.onFilteringChange}
        maxLength={this.maxLength}
        onSave={this.onSave}
        entity={this.entity}
        onRowClick={this.props.editable ? this.onRowClick : undefined}
        editable={this.props.editable}
        selectedDocument={this.state.selectedDocument}
        onDocumentEditChange={this.onDocumentEditChange}
        showEditDialog={this.state.showEditDialog}
        handleCloseEditDialog={this.handleCloseEditDialog}
        showUploader={this.state.showUploader}
        handleShowUploader={this.handleShowUploader}
        handleCloseUploader={this.handleCloseUploader}
        setSelected={this.setSelected}
        hideCreateForm={this.props.hideCreateForm}
        onShowSimilarDocuments={this.onShowSimilarDocuments}
        showSimilarDocuments={this.state.showSimilarDocuments}
        handleCloseSimilarDocuments={this.handleCloseSimilarDocuments}
        messageHandler={this.messageHandler}
        breadcrumbsHandler={this.breadcrumbsHandler}
        documentTypes={docTypesOptions}
      />
    );
  }
}

export default withKeycloak(DocumentContainer);
